"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = Text;
exports.disclaimerDataPropTypes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _themeProvider = require("@mmc/theme-provider");
var _disclaimerBox = _interopRequireWildcard(require("./disclaimer-box/disclaimer-box"));
var _getDataFromTextComponent = _interopRequireDefault(require("./handlers/getDataFromTextComponent/getDataFromTextComponent"));
var _getDisclaimersInText = _interopRequireDefault(require("./handlers/getDataFromTextComponent/utils/getDisclaimersInText"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable jsx-a11y/click-events-have-key-events */

function Text(_ref) {
  var _cloneElement2;
  var TextComponent = _ref.text,
    disclaimerData = _ref.disclaimerData,
    Tag = _ref.tag,
    className = _ref.className,
    automation = _ref.automation,
    enableEventPropagation = _ref.enableEventPropagation,
    disclaimerButtonSpacing = _ref.disclaimerButtonSpacing,
    tooltipPlacement = _ref.tooltipPlacement,
    setDisclaimerFontSizePrcnt = _ref.setDisclaimerFontSizePrcnt;
  var textRef = (0, _react.useRef)(null);
  var theme = (0, _themeProvider.useTheme)();
  var _useState = (0, _react.useState)(''),
    textToDisplay = _useState[0],
    setTextToDisplay = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    vanillaDisclaimerBoxes = _useState2[0],
    setVanillaDisclaimerBoxes = _useState2[1];
  if (!TextComponent) {
    return null;
  }
  if (!disclaimerData || typeof TextComponent === 'number') {
    return /*#__PURE__*/_react["default"].createElement(Tag, {
      className: className,
      automation: automation
    }, TextComponent);
  }
  var _useState3 = (0, _react.useState)(0),
    value = _useState3[0],
    setValue = _useState3[1];
  var _useMemo = (0, _react.useMemo)(function () {
      return (0, _getDataFromTextComponent["default"])(TextComponent);
    }, [TextComponent]),
    isRichText = _useMemo.isRichText,
    textProp = _useMemo.textProp,
    textRaw = _useMemo.textRaw,
    textComponentIsString = _useMemo.textComponentIsString;
  var addDisclaimersToText = function addDisclaimersToText(mode) {
    if (textToDisplay === '' || textToDisplay.length === 0 || mode === 'update') {
      var vanillaDisclaimerBoxesLocal = [];
      var textsOrDisclaimers = (0, _getDisclaimersInText["default"])(textRaw, disclaimerData);
      var Disclaimers = textsOrDisclaimers.map(function (textOrDisclaimer, index) {
        var nextWord = textsOrDisclaimers[index + 1];
        var prevWord = textsOrDisclaimers[index - 1];
        var prevIsDisclaimer = typeof prevWord === 'object';
        var isDisclaimer = typeof textOrDisclaimer === 'object';
        var nextIsDisclaimer = typeof nextWord === 'object';
        var extraClass = '';
        if (typeof textOrDisclaimer === 'string' && !nextIsDisclaimer) {
          var previousWord = prevWord || '';
          var previousWordIsDisclaimer = typeof previousWord === 'object';
          var text = previousWordIsDisclaimer ? " " + textOrDisclaimer : textOrDisclaimer;
          if (isRichText) {
            extraClass = 'addMarginRight';
          }
          if (prevIsDisclaimer && text === ' .') {
            text = text.trim();
          }
          return text + " ";
        }
        if (isDisclaimer) {
          var id = textOrDisclaimer.id,
            detail = textOrDisclaimer.detail;
          var _ref2 = textRef.current ? window.getComputedStyle(textRef.current) : {},
            textFontSize = _ref2.fontSize,
            textFontFamily = _ref2.fontFamily;
          var disclaimer = !prevIsDisclaimer ? prevWord : '';
          if (nextWord === '.') {
            extraClass = ' ';
          }
          if (isRichText) {
            var newVanillaDisclaimerBox = (0, _disclaimerBox.createVanillaDisclaimerBox)({
              disclaimer: disclaimer,
              disclaimerId: id,
              disclamerText: detail,
              theme: theme,
              textFontSize: textFontSize,
              textFontFamily: textFontFamily,
              disclaimerButtonSpacing: disclaimerButtonSpacing,
              extraClass: extraClass,
              tooltipPlacement: tooltipPlacement,
              setDisclaimerFontSizePrcnt: setDisclaimerFontSizePrcnt
            });
            vanillaDisclaimerBoxesLocal.push(newVanillaDisclaimerBox);
            return newVanillaDisclaimerBox.component;
          }
          return /*#__PURE__*/_react["default"].createElement(_disclaimerBox["default"], {
            key: id,
            disclaimer: disclaimer,
            disclaimerId: id,
            disclamerText: detail,
            textFontSize: textFontSize,
            textFontFamily: textFontFamily,
            disclaimerButtonSpacing: disclaimerButtonSpacing,
            tooltipPlacement: tooltipPlacement,
            setDisclaimerFontSizePrcnt: setDisclaimerFontSizePrcnt
          });
        }
        return '';
      });
      if (isRichText && vanillaDisclaimerBoxes.length === 0 || mode === 'update') {
        setVanillaDisclaimerBoxes(vanillaDisclaimerBoxesLocal);
        return setTextToDisplay(Disclaimers.filter(Boolean).join(' '));
      }
      setTextToDisplay(Disclaimers);
    }
  };
  (0, _react.useEffect)(function () {
    var textToDisplayToSearch = textToDisplay && typeof textToDisplay === 'string' && (textToDisplay.includes('<span') && textToDisplay.split('<span')[0].split(' ').filter(function (c) {
      return c !== '' && c !== '\n';
    }).join('') || textToDisplay.split(' ').filter(Boolean).join(''));
    if (disclaimerData && TextComponent && textRaw && textRaw.match(/#/) && (textToDisplay === '' || textToDisplay.length === 0)) {
      addDisclaimersToText();
    } else if (textToDisplay === '') {
      setTextToDisplay(textRaw);
    } else if (textRaw && textToDisplay && typeof textRaw === 'string' && typeof textToDisplay === 'string' && textToDisplayToSearch && !textRaw.replace(/\s/g, '').includes(textToDisplayToSearch)) {
      // this condition helps updating the component when props have been updated like 'textRaw'
      // but the actual display 'textToDisplay' haven't been updated like it should
      // for eg: in tab-gallery component
      addDisclaimersToText('update');
    }
    if (typeof document !== 'undefined' && textToDisplay) {
      if (vanillaDisclaimerBoxes.length) {
        vanillaDisclaimerBoxes.forEach(function (vanillaDisclaimerBox) {
          vanillaDisclaimerBox.initialize();
        });
      }
    }
  }, [textToDisplay, vanillaDisclaimerBoxes, textRaw]);
  (0, _react.useEffect)(function () {
    if (value === 0) {
      setValue(function (v) {
        return v + 1;
      });
    }
  }, []);
  var preventEventBubbling = function preventEventBubbling(e) {
    if (enableEventPropagation || isRichText) return;
    e.preventDefault();
    e.stopPropagation();
  };
  if (textComponentIsString) {
    return /*#__PURE__*/_react["default"].createElement(Tag, {
      ref: textRef,
      className: className,
      automation: automation,
      onClick: preventEventBubbling,
      key: value
    }, textToDisplay);
  }
  if (isRichText) {
    var _cloneElement;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: className,
      onClick: preventEventBubbling,
      ref: textRef,
      key: value
    }, /*#__PURE__*/(0, _react.cloneElement)(TextComponent, (_cloneElement = {}, _cloneElement[textProp] = textToDisplay, _cloneElement)));
  }
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    className: className,
    onClick: preventEventBubbling,
    ref: textRef,
    key: value
  }, /*#__PURE__*/(0, _react.cloneElement)(TextComponent, (_cloneElement2 = {}, _cloneElement2[textProp] = textToDisplay, _cloneElement2)));
}
var disclaimerDataPropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  id: _propTypes["default"].string,
  detail: _propTypes["default"].string
}));
exports.disclaimerDataPropTypes = disclaimerDataPropTypes;
Text.defaultProps = {
  tag: 'p',
  className: ''
};